import React from 'react';

const NotificationIcon = (props) => (
    <svg {...props} fill="currentColor" className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path
            className="st0"
            d="M456.4,360.8c-32.3-27.3-50.8-67.1-50.8-109.3V192c0-75.1-55.8-137.2-128-147.6v-23c0-11.8-9.6-21.3-21.3-21.3
	C244.6,0,235,9.5,235,21.3v23C162.7,54.8,107,116.9,107,192v59.5c0,42.2-18.5,82.1-50.9,109.5c-8.3,7.1-13.1,17.4-13.1,28.4
	c0,20.6,16.7,37.3,37.3,37.3h352c20.6,0,37.3-16.7,37.3-37.3C469.7,378.4,464.9,368.1,456.4,360.8z"
        />
        <path className="st0" d="M256.3,512c38.6,0,71-27.5,78.4-64H178C185.4,484.5,217.7,512,256.3,512z" />
    </svg>
);

export default NotificationIcon;
